import { clsx } from 'clsx';
import { PropsWithChildren } from 'react';

import s from './DetailsSection.module.scss';

interface Props {
  editView?: boolean;
  missingData?: boolean;
  missingDataAlert?: boolean;
  classes?: {
    root?: string;
    editView?: string;
    missingDataAlert?: string;
  };
}

export function DetailsSection(props: PropsWithChildren<Props>) {
  const { children, editView, missingData, missingDataAlert, classes } = props;

  return (
    <div
      className={clsx(s.root, classes?.root, {
        [s.editView]: editView,
        [s.missingData]: missingData,
        [s.missingDataAlert]: missingDataAlert,
        [classes?.editView || '']: editView && classes?.editView,
        [classes?.missingDataAlert || '']: missingDataAlert && classes?.missingDataAlert,
      })}
    >
      {children}
    </div>
  );
}
